export enum LegalDocumentType {
  CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
  REGISTER_OF_MEMBERS = 'REGISTER_OF_MEMBERS',
  REGISTER_OF_DIRECTORS = 'REGISTER_OF_DIRECTORS'
}
